import { useEffect, useState } from "react";
import Header from "./components/Header";
import Hero from "./components/Hero";
import LiveSection from "./components/LiveSection";
import EventsSection from "./components/EventsSection";
import ThemeSection from "./components/ThemeSection";
import GallerySection from "./components/GallerySection";
import CollectionsSection from "./components/CollectionsSection";
import TrendingSection from "./components/TrendingSection";
import FaqSection from "./components/FaqSection";
import AboutSection from "./components/AboutSection";
import Footer from "./components/Footer";
import Toast from "./components/Toast";

function BackTop() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 560);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <button
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      aria-label="回到顶部"
      className={`fixed bottom-6 right-6 z-[75] w-11 h-11 flex items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-lg hover:bg-primary-600 transition-all cursor-pointer ${
        show ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"
      }`}
    >
      <i className="ri-arrow-up-line text-lg"></i>
    </button>
  );
}

export default function Home() {
  return (
    <div className="w-full min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <LiveSection />
        <EventsSection />
        <ThemeSection />
        <GallerySection />
        <CollectionsSection />
        <TrendingSection />
        <FaqSection />
        <AboutSection />
      </main>
      <Footer />
      <BackTop />
      <Toast />
    </div>
  );
}